var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.spinner && _vm.buses.length == 0)?_c('div',{directives:[{name:"center",rawName:"v-center"}]},[_c('h1',[_vm._v("no hay Buses")])]):_vm._e(),(_vm.spinner)?_c('Spinner',{attrs:{"color":"#fedd00"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }